export enum PropertyUsages {
    Residential,
    Commercial
}